import { Component, computed, inject } from '@angular/core';
import { DateUtilsService } from '@core/utils/date-utils.service';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AnalysisNavigationService } from 'demand-forecasting/analysis/services/analysis-navigation.service';
import { AnalysisStateService } from 'demand-forecasting/analysis/services/analysis-state.service';
import { selectAnalysisVersionIdByQueryParam } from 'demand-forecasting/store/router-state/router.selectors';
import { FormFieldComponent, FormInputSelectComponent } from '@libs/ui';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'pm-analysis-version-picker',
  templateUrl: './analysis-version-picker.component.html',
  imports: [
    TranslateModule,
    FormFieldComponent,
    FormInputSelectComponent,
    FormsModule,
  ],
})
export class AnalysisVersionPickerComponent {
  private readonly store = inject(Store);
  private readonly dateUtilsService = inject(DateUtilsService);

  protected analysisStateService = inject(AnalysisStateService);
  private readonly analysisNavigationService = inject(
    AnalysisNavigationService,
  );

  protected selectedAnalysisVersionId = this.store.selectSignal(
    selectAnalysisVersionIdByQueryParam,
  );

  protected versionValue = computed(() => {
    const selectedAnalysisVersionId = this.selectedAnalysisVersionId();
    const values = this.analysisVersionOptions();

    if (!selectedAnalysisVersionId && values.length) {
      this.versionSelectionChanged(values[0]?.value);
    }

    return selectedAnalysisVersionId;
  });

  protected analysisVersionOptions = computed(() => {
    if (!this.analysisStateService.versions.hasValue()) {
      return [];
    }
    return this.analysisStateService.versions.value().map((v) => ({
      label: this.dateUtilsService.formatDateBasedOnLanguage(v.createdAt),
      value: v.id,
      createdAt: v.createdAt,
    }));
  });

  protected versionSelectionChanged(
    versionId: string | (string | undefined)[] | undefined,
  ) {
    if (!versionId || Array.isArray(versionId)) {
      return;
    }

    this.analysisNavigationService.setQueryParams({
      versionId,
      filter: null,
      hierarchy: null,
    });
  }
}
